/* eslint-disable no-undef */

export default {
	name: "data-table",
	props: ["fieldToDetermineColumnColor", "headings", "data", "hasActions", "hasCustomActionComponent", "hasNoFilter", "pagingDetails", "hasNoPaging", "increasePagingWidth", "stateChanged"],
	emits: ["actionClicked", "filterSearchClicked", "pagingUpdated"],
	data() {
		return {
			tableHeadings: null,
			tableData: null,
			tableActions: null,
			searchTypingTimer: null,
			pagingNumberTypingTimer: null,
			pageHasLoaded: false,
			oldPageNumber: 1,
			pagingInfo:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: null,
				hasPaging: true
			},
			showActions: true,
			fieldToUseToDetermineColumnColor: null
		};
	},
	methods: {
		onActionItemClicked(data, action) {
			var actionAndData = {
				data: data,
				action: action
			};
			this.$emit("actionClicked", actionAndData);
		},
		onFilterSearchClick(){
			this.$emit("filterSearchClicked", true);
		},
		onPageNumberInput(){
			var self = this;
			console.log("newValue", this.pagingInfo.pageNumber);
			if(this.pagingInfo.pageNumber !== "" && this.pagingInfo.pageNumber !== null){
				var selectedPageNumber = parseInt(this.pagingInfo.pageNumber);
				if(selectedPageNumber <= 0){
					//this.canLoadDocuments = false;
					this.pagingInfo.pageNumber = this.oldPageNumber;
				}
				else if(selectedPageNumber > this.pagingInfo.totalPages){
					//this.canLoadDocuments = false;
					this.pagingInfo.pageNumber = this.oldPageNumber;
				}
				else{
					clearTimeout(self.pagingNumberTypingTimer);
					self.pagingNumberTypingTimer = setTimeout(function(){
						self.$emit("pagingUpdated", self.pagingInfo);
						clearTimeout(self.pagingNumberTypingTimer);
						self.pagingNumberTypingTimer = null;
						self.oldPageNumber = self.pagingInfo.pageNumber;
					}, 3000);
				}
			}
			// else{
			//     this.canLoadDocuments = false;
			//     this.pagingInfo.pageNumber = this.oldPageNumber;
			// }
		},
		onPageNumberBlur(){
			if(this.pagingInfo.pageNumber === null || this.pagingInfo.pageNumber === ""){
				this.pagingInfo.pageNumber = this.oldPageNumber;
			}
		},
		nextPage(){
			if(this.pagingInfo.pageNumber !== this.pagingInfo.totalPages){
				this.pagingInfo.pageNumber++;
				this.oldPageNumber = this.pagingInfo.pageNumber;
				this.$emit("pagingUpdated", this.pagingInfo);
			}
		},
		previousPage(){
			if (this.pagingInfo.pageNumber > 1) {
				this.pagingInfo.pageNumber--;
				this.oldPageNumber = this.pagingInfo.pageNumber;
				this.$emit("pagingUpdated", this.pagingInfo);
			}
		},
	},
	mounted: function () {

	},
	watch: {
		headings: {
			handler: function () {
				if(this.headings){
					this.tableHeadings = this.headings;
					console.log("tableHeadings", this.tableHeadings);
				}
			},
			immediate: true,
			deep: true
		},
		data:{
			handler: function () {
				if(this.data){
					this.tableData = this.data;
					var self = this;
					setTimeout(function (){
						permissionsHelper.setDataTableActionsBasedOnPermissions();
						let actionDropdownDataTableMenu = document.getElementById("actionDropdownDataTableMenu");
						var hiddenActionItemsCount = 0;
						var hiddenActionItemChildrenCount = 0;
						if(actionDropdownDataTableMenu !== null){
							for(let i = 0; i < actionDropdownDataTableMenu.children.length; i++){
								// if(actionDropdownDataTableMenu.children[i].classList.contains("hide-element")){
								// 	hiddenActionItemsCount++;
								// }
								for(var j = 0; j < actionDropdownDataTableMenu.children[i].children.length; j++){
									if(actionDropdownDataTableMenu.children[i].children[j].classList.contains("hide-element")){
										hiddenActionItemChildrenCount++;
									}
								}
								if(actionDropdownDataTableMenu.children[i].children.length === hiddenActionItemChildrenCount){
									hiddenActionItemsCount++;
								}
								hiddenActionItemChildrenCount = 0;
							}
							if(actionDropdownDataTableMenu.children.length === hiddenActionItemsCount){
								self.showActions = false;
							}
						}

					}, 50);

				}
			},
			immediate: true,
			deep: true
		},
		pagingDetails:{
			handler: function () {
				if(this.pagingDetails){
					this.pagingInfo = this.pagingDetails;
					//this.oldPageNumber = this.pagingInfo.pageNumber;
					console.log("pagingInfo", this.pagingInfo);
					console.log("oldPageNumber", this.oldPageNumber);
				}
			},
			immediate: true,
			deep: true
		},
		hasActions:{
			handler: function (){
				if(this.hasActions){
					this.showActions = this.hasActions;
				}
				else{
					this.showActions = false;
				}

			},
			immediate: true,
			deep: true
		},
		fieldToDetermineColumnColor:{
			handler: function (){
				if(this.fieldToDetermineColumnColor !== null && this.fieldToDetermineColumnColor !== ""){
					this.fieldToUseToDetermineColumnColor = this.fieldToDetermineColumnColor;
				}
				console.log("fieldToUseToDetermineColumnColor", this.fieldToUseToDetermineColumnColor);
			},
			immediate: true,
			deep: true
		}
		// actions:{
		// 	handler: function () {
		// 		if(this.actions){
		// 			this.tableActions = this.actions;
		// 		}
		// 	},
		// 	immediate: true,
		// 	deep: true
		// }
	}
};
